(() => {
  var modules = {

    // Accordion single open
    82: () => {
      const container = document.querySelector(".c-collection-sidebar .c-accordions");
      if (container && container.dataset.type === "single") {
        const accordions = container.querySelectorAll(".c-accordion");
        accordions.forEach(acc => {
          const checkbox = acc.querySelector(".c-accordion-checkbox");
          checkbox.addEventListener("change", () => {
            if (checkbox.checked) {
              accordions.forEach(a => {
                if (a !== acc) a.querySelector(".c-accordion-checkbox").checked = false;
              });
            }
          });
        });
      }
    },

    // Slider
    143: () => {
      document.querySelectorAll(".c-slider-wrap.featured-products").forEach(wrap => {
        const slider = wrap.querySelector(".c-slider");
        if (!slider) return;
        new Swiper(slider, {
          loop: true,
          slidesPerView: 1.33,
          speed: 500,
          autoplay: { delay: 2000, disableOnInteraction: false },
          spaceBetween: 16,
          pagination: {
            el: wrap.closest(".o-sec").querySelector(".c-slider-pagination"),
            clickable: true
          },
          breakpoints: {
            768: { slidesPerView: 2.33, spaceBetween: 24 },
            992: { slidesPerView: 3.33 }
          }
        });
      });
    },

    // Load More
    334: () => {
      const btn = document.querySelector(".load-more");
      const grid = document.querySelector(".c-grid.collection");
      const cards = document.querySelectorAll(".c-product-card");
      if (!btn || !grid) return;

      let limit = parseInt(grid.dataset.pagination);
      btn.addEventListener("click", () => {
        limit += parseInt(grid.dataset.pagination);
        cards.forEach((c, i) => i < limit && c.classList.add("loaded"));
        if (limit >= cards.length) btn.closest(".c-load-more").style.display = "none";
      });
    },

    // Sorting
    491: () => {
      const buttons = document.querySelectorAll(".c-dropdown-item button");
      const grid = document.querySelector(".c-grid.collection");
      const cards = Array.from(document.querySelectorAll(".c-product-card"));

      buttons.forEach(btn => {
        btn.addEventListener("click", () => {
          const sort = btn.dataset.sort;
          cards.sort((a, b) => {
            if (sort.includes("title")) {
              return sort === "title-asc"
                ? a.dataset.title.localeCompare(b.dataset.title)
                : b.dataset.title.localeCompare(a.dataset.title);
            }
            return sort === "price-asc"
              ? a.dataset.price - b.dataset.price
              : b.dataset.price - a.dataset.price;
          });

          grid.innerHTML = "";
          cards.forEach(c => grid.appendChild(c));
          buttons.forEach(b => b.classList.remove("active"));
          btn.classList.add("active");
        });
      });
    },

    // ✅ FILTER FIX (All Products / All Phases)
    589: () => {
      const filters = document.querySelectorAll(".c-filter-checkbox");
      const products = document.querySelectorAll(".c-product-card");
      const empty = document.querySelector(".c-collection-empty");

      let activeFilters = [];

      filters.forEach(cb => {
        cb.addEventListener("change", () => {
          const name = cb.name;
          const value = cb.value;
          const key = `${name}-${value}`;

          if (value === "all") {
            activeFilters = activeFilters.filter(f => !f.startsWith(name + "-"));
            if (!cb.checked) return;
          } else {
            if (cb.checked) activeFilters.push(key);
            else activeFilters = activeFilters.filter(f => f !== key);
          }

          let visible = 0;

          products.forEach(p => {
            const data = p.dataset.filters.split(",");
            const groups = {};

            activeFilters.forEach(f => {
              const g = f.split("-")[0];
              groups[g] = groups[g] || [];
              groups[g].push(f);
            });

            const match = Object.values(groups).every(group =>
              group.some(f => {
                if (f.startsWith("price-")) {
                  return parseInt(p.dataset.price) <= parseInt(f.replace("price-", ""));
                }
                return data.includes(f);
              })
            );

            p.classList.toggle("filtered", !match && activeFilters.length);
            if (match || !activeFilters.length) visible++;
          });

          empty.classList.toggle("active", visible === 0);
        });
      });
    },
    // Cart Close Fix
777: () => {
  document.addEventListener("click", function(e){

    const closeBtn = e.target.closest(".c-cart-close");
    if(!closeBtn) return;

    document.body.classList.remove("js-cart-open");

    const cart = document.querySelector("[data-cart-root]");
    if(cart) {
      cart.classList.remove("is-open");
      const btn = document.querySelector('[data-cart-trigger]');
      if(btn) btn.setAttribute('aria-expanded', 'false');
    }

  });
},

    // Mobile Menu Toggle
888: () => {
  const menuBtn = document.querySelector(".c-menu-btn");
  const nav = document.querySelector(".c-header-nav");
  const header = document.querySelector(".c-header");
  
  if (!menuBtn || !nav || !header) return;
  
  menuBtn.addEventListener("click", () => {
    const isOpen = header.classList.contains("open");
    
    if (isOpen) {
      header.classList.remove("open");
      nav.style.display = "none";
    } else {
      header.classList.add("open");
      nav.style.display = "flex";
    }
  });
},

    // Filters Toggle
999: () => {
  const filterToggle = document.querySelector(".c-filters-toggle");
  const sidebar = document.querySelector(".c-collection-sidebar");
  
  if (!filterToggle || !sidebar) return;
  
  filterToggle.addEventListener("click", () => {
    filterToggle.classList.toggle("active");
    sidebar.classList.toggle("is-open");
  });
},

    // Sort Dropdown Toggle
1010: () => {
  const dropdowns = document.querySelectorAll(".c-dropdown-wrap");
  
  dropdowns.forEach(dropdown => {
    const toggle = dropdown.querySelector(".c-dropdown-toggle");
    if (!toggle) return;
    
    toggle.addEventListener("click", (e) => {
      e.stopPropagation();
      dropdown.classList.toggle("is-open");
    });
  });
  
  // Close dropdowns when clicking outside
  document.addEventListener("click", () => {
    dropdowns.forEach(dropdown => {
      dropdown.classList.remove("is-open");
    });
  });
}
  };

  var cache = {};
const require = id => cache[id] || (cache[id] = { exports: modules[id]() });

function initModules() {
  require(82);
  require(143);
  require(334);
  require(491);
  require(589);
  require(777);
  require(888);
  require(999);
  require(1010);
}

// first load
initModules();

// after ajax cart update
document.addEventListener("liquid-ajax-cart:request-end", function () {
  initModules();
});


  /* ✅ IMAGE CLARITY SAFETY FIX (VERY IMPORTANT) */
  document.querySelectorAll("img[data-src]").forEach(img => {
    img.src = img.dataset.src;
    img.removeAttribute("data-src");
    img.removeAttribute("srcset");
    img.removeAttribute("sizes");
  });

})();
